/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Email_ColInputs */

const en_admin_users_email_col = /** @type {(inputs: Admin_Users_Email_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_admin_users_email_col = /** @type {(inputs: Admin_Users_Email_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Admin_Users_Email_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_email_col = /** @type {((inputs?: Admin_Users_Email_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Email_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_email_col(inputs)
	return zh_admin_users_email_col(inputs)
});
export { admin_users_email_col as "admin.users.email_col" }